export default {
  "notifications": {
    "broken_favorite": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["סטאטוס לא ידוע, מחפש…"])},
    "favorited_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אהב את הסטטוס שלך"])},
    "followed_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["עקב אחריך"])},
    "load_older": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["טען התראות ישנות"])},
    "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["התראות"])},
    "read": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קרא!"])},
    "repeated_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["חזר על הסטטוס שלך"])},
    "no_more_notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לא עוד התראות"])}
  }
}